import React from "react";
import { IToastProps } from "@swiggy-private/dls-web-recipe-food-web/dist/components/Toast/types";

export interface CartToastContextValue {
    cartToastData: IToastProps;
    setCartToastData: React.Dispatch<React.SetStateAction<CartToastContextValue["cartToastData"]>>;
}

export const INITIAL_CART_TOAST_CONTEXT_VALUE = {
    cartToastData: {
        message: "",
        show: false,
    },
    setCartToastData: () => void 0,
};

export const CartToastContext = React.createContext<CartToastContextValue>(INITIAL_CART_TOAST_CONTEXT_VALUE);

if (__DEV__) {
    CartToastContext.displayName = "CartToastContext";
}
